import React, { useEffect, useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import './HeaderFooter.css';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import axios from 'axios';
import ApprovalProcessService from '../services/ApprovalProcessService';
import { ajaxPrefilter } from 'jquery';

const Header = () => {
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);
  const employeeName = localStorage.getItem('username') || "User";
  const empcode=localStorage.getItem('empcode');
  const role = localStorage.getItem('role');
  const [marqueeMessage, setMarqueeMessage] = useState('');


  
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await ApprovalProcessService.getMenuListData(empcode);
        const flatMenu = response.data.result;

        // Convert flat menu to nested tree
        const menuMap = {};
        const menuTree = [];

        flatMenu.forEach(item => {
          menuMap[item.menuID] = {
            id: item.menuID,
            name: item.menuName,
            path: item.menuPath,
            icon: item.iconClass,
            parentID: item.parentMenuID,
            children: [],
          };
        });

        Object.values(menuMap).forEach(item => {
          if (item.parentID === null) {
            menuTree.push(item);
          } else if (menuMap[item.parentID]) {
            menuMap[item.parentID].children.push(item);
          }
        });

        setMenuItems(menuTree);
      } catch (error) {
        console.error("Failed to load menu", error);
      }
    };
    const fetchMarquee = async () => {
    try {
       const res = await ApprovalProcessService.getMarqueeMsg();
      setMarqueeMessage(res.data.result);

    } catch (error) {
      console.error("Failed to load marquee", error);
    }
  };

    fetchMenu();
     fetchMarquee();
  }, [role]);

  const handleLogout = () => {
    // Clear all authentication data
    localStorage.removeItem('username');
    localStorage.removeItem('empcode');
    localStorage.removeItem('token');
    localStorage.removeItem('role'); // optional, if you store it
    // Redirect to login page
    navigate('/');
  };

  return (
    <>
     {marqueeMessage && (
    <div className="marquee-bar">
      <div className="marquee-text">
        {marqueeMessage}
      </div>
    </div>
  )}
    <Navbar expand="md" className="custom-header" variant="dark">
      <Container fluid>
        <Navbar.Brand className="text-white d-flex align-items-center">
          <NavLink to="/home" className="text-white text-decoration-none">
            {/* <i className="fas fa-home me-2 fs-4"></i> */}
            
             <img 
             src={`${process.env.PUBLIC_URL}/logo.png`}
             //src="https://apps.genus.in/NIVARAN/img/genus_logo.png"
             />
          </NavLink>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto ms-3">
            {menuItems.map((item, index) =>
              item.children && item.children.length > 0 ? (
                <Nav.Item className="nav-item-dropdown" key={index}>
                  <span className="nav-link text-white">
                    <i className={`${item.icon} me-1`}></i> {item.name}
                  </span>
                  <div className="dropdown-menu">
                    {item.children.map((child, cIndex) => (
                      <NavLink to={child.path} className="dropdown-item text-dark" key={cIndex}>
                        {child.name}
                      </NavLink>
                    ))}
                  </div>
                </Nav.Item>
              ) : (
                <NavLink to={item.path} className="nav-link text-white" key={index}>
                  <i className={`${item.icon} me-1`}></i> {item.name}
                </NavLink>
              )
            )}
          </Nav>

          <div className="d-flex align-items-center text-white">
            <span className="me-3 d-none d-sm-inline">
              <i
      className="fas fa-user-circle me-2"
      style={{ cursor: "pointer" ,  color: "#fd0d71",      // Blue
    fontSize: "20px",}}
      onClick={() => navigate("/EmployeeProfile")}
    ></i> Welcome, {employeeName}
            </span>
            <Button className="btn btn-sm custom-logout-btn" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt me-1"></i> Logout
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
};

export default Header;
